/**
 * Shared display helpers.
 *
 * TRIMMED 2026-09-30. This file carried 12 exports for 3 importers. Nine were dead —
 * capitalizeFirst, debounce, downloadFile, formatNumber, generateId, isMobile, isValidEmail,
 * scrollToElement, truncateText — and are gone.
 *
 * `formatDate` was removed too, and deliberately NOT replaced. It shared a name with
 * `pages/admin/adminUtils.js:formatDate` but not its behaviour: this one did
 * `new Date("2026-08-13")`, which JS parses as UTC MIDNIGHT and then renders a day early west
 * of Greenwich — the exact bug adminUtils carries a seven-line comment about having fixed
 * ("28 visitors showed up on Aug 12"). Nothing imported this copy; every formatDate in the
 * tree resolves to adminUtils. Use that one. Do not reintroduce a second spelling here.
 */

export const formatDuration = (duration) => {
  if (!duration && duration !== 0) return null; // Return null if no duration

  let seconds = 0;

  // Handle different input formats
  if (typeof duration === 'string') {
    // Remove "minutes" text if present (legacy format)
    const cleanDuration = duration.replace(/\s*minutes?\s*/i, '').trim();
    const numValue = parseFloat(cleanDuration);

    if (!isNaN(numValue)) {
      // Duration is stored in seconds
      seconds = numValue;
    } else {
      return null; // Return null for invalid strings
    }
  } else if (typeof duration === 'number') {
    // Duration is stored in seconds
    seconds = duration;
  }

  // Convert seconds to MM:SS format
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.round(seconds % 60);
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};

export const displayTitle = (title) =>
  (title || "").replace(
    /^(Problem Solution: |Solution: |Educational Video: |The student is working on this problem: |The student is studying this topic: |Their follow-up request: )/,
    "",
  );
